/**
 * 为「一次提交」生成 `Idempotency-Key`：格式须落在后端 `normalizeIdempotencyKey` 的闸门内
 * （8–64 位，首字符字母数字，其余可含下划线/短横线），否则直接吃 400。
 *
 * 有意不用 `crypto.randomUUID()` 兜底：它在非安全上下文（http://局域网IP 的开发机）里不存在，
 * 而 `getRandomValues` 全环境可用，一条路径反而更短。
 */
export function createIdempotencyKey(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let key = '';
  for (const b of bytes) key += b.toString(16).padStart(2, '0');
  return key;
}
